import React from "react";
import PropTypes from "prop-types";
import "./styles/index.scss";

const getClassName = (type, shift) => {
  let result = "";
  if (type) {
    result += type;
  }
  if (shift) {
    result += " shift-" + shift;
  }
  return result;
};

const Delimiter = ({ type, shift }) => {
  return <hr className={getClassName(type, shift)} />;
};

Delimiter.propTypes = {
  type: PropTypes.string,
};

export default Delimiter;
